import states from "./states"
import {
  GF_UPDATE_STATE,
  GF_MORE_FAQS_LOADED,
  GF_FAQ_CREATED,
  GF_FAQ_UPDATED,
  GF_FAQ_DELETED,
} from "./actiontypes"
import { MODULE_CONFIG } from "../../config/setup"

const genai_faq_details = (state = states.genai_faq_details, action) => {
  switch (action.type) {
    case GF_UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      }

    case GF_MORE_FAQS_LOADED:
      return {
        ...state,
        faqs: [...state.faqs, ...action.payload],
        gf_has_more:
          action.payload.length ===
          MODULE_CONFIG.GENAI_CLASSIFIER.GF_RECORDS_PER_PAGE_DATA,
      }

    case GF_FAQ_CREATED:
      return {
        ...state,
        faqs: [action.payload, ...state.faqs],
      }

    case GF_FAQ_UPDATED: {
      let index = -1
      index = state.faqs.findIndex(faq => faq.id === action.payload.id)
      if (index !== -1)
        return {
          ...state,
          faqs: [
            ...state.faqs.slice(0, index),
            {
              ...state.faqs[index],
              ...action.payload,
            },
            ...state.faqs.slice(index + 1),
          ],
        }
      return state
    }

    case GF_FAQ_DELETED: {
      let index = -1
      index = state.faqs.findIndex(faq => faq.id === action.payload)
      if (index !== -1)
        return {
          ...state,
          faqs: [
            ...state.faqs.slice(0, index),
            ...state.faqs.slice(index + 1),
          ],
        }
      return state
    }

    default:
      return state
  }
}

export default genai_faq_details
